
define('text!templates/grid_subItem.html',[],function () { return '{{#list}}\n     {{>listItem}}\n{{/list}}\n\n';});

